import styled from 'styled-components';
import { TextField as MUITextField } from '@mui/material';

export const TextField = styled(MUITextField)`
  width: 100%;
  height: 56px;
`;
